import { FoodsIcon } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type HeaderActions = {
    isEdit: boolean;
    toggleEdit: () => void;
};
export const HeaderActions = (props: HeaderActions) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isEdit, toggleEdit } = props;

    return (
        <Stack gap={theme.spacing(1)} flexDirection="row" alignItems={"center"} justifyContent={"center"}>
            {isEdit ?
                <Button variant="validate" startIcon={<FoodsIcon size={2} icon={"check"} />} onClick={toggleEdit}>
                    <Typography variant={"body-medium"} color={"inherit"}>
                        {t("action-plan.list.confirm")}
                    </Typography>
                </Button>
            :   <Button variant="primary" startIcon={<FoodsIcon size={2} icon={"edit"} />} onClick={toggleEdit}>
                    <Typography variant={"body-medium"} color={"inherit"}>
                        {t("action-plan.list.edit")}
                    </Typography>
                </Button>
            }
        </Stack>
    );
};
